<template>
  <div>
    <Table
      :data="searches"
      :config="config"
      noContentMessage="No searches yet."
    ></Table>
  </div>
</template>

<script setup lang="ts">
import moment from 'moment';
import Table from "~/components/Table.vue";
import { useSearchStore } from "~/store";
import type { Client, Search } from "~/common/types/types";
import ellipsize from "ellipsize";

const searchStore = useSearchStore();

const props = defineProps({
  client: {
    type: Object as PropType<Client>,
    required: true,
  },
});

const searches = computed(() => searchStore.getSearches(props.client._id));

const mappings = {
  _id: { column: false },
  clientId: { column: false },
  description: (c: Search) => ellipsize(c.description, 200),
  results: (c: Search) => c.results.length,

  // parentId: {
  //   column: "Parent",
  //   cell: (profile: Search) => {
  //     if (!profile.parentId) return;
  //     const parentSearch = store.getSearch(profile.parentId);
  //     return parentSearch.name;
  //   },
  // },
  updated: {
    //order: 1,
    //column: "Scheduled",
    cell: (search: Search) =>
      `${moment(search.updated).format("YYYY-MM-DD")}`,
  },
};

const actions = [
  {
    title: "Open",
    type: "open",
    to: (item: Search) => ({
      path: `/searches/${item._id}`,
    }),
  },
  {
    title: "Delete",
    type: "delete",
    click: async (item: Search) => {
      await searchStore.deleteSearch(item);
    },
  },
];

const config = {
  mappings: mappings,
  actions: actions,
};
</script>
